import { useEffect, useRef, useState } from "react";
import { useAuthStore, useNonPersistAuthStore } from "../AuthStore/AuthStore";
import LoginPage from "../Pages/Login/Login";
import DocumentView from "../Pages/DocumentView/DocumentView";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import ProtectedRoute from "./ProtectedRoute";
import { API, APIwithoutInterceptor } from "../Axios/Axios";
import Header from "../Layout/Header/Header";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Sidebar from "../Layout/Sidebar/Sidebar";
import Footer from "../Layout/Footer/Footer";
import CustomErrorPage from "../Pages/CustomErrorPage/CustomErrorPage";
import DyanmicFormComponent from "../Components/DynamicForm/DynamicForm";
import StateMasterDashboard from "../Pages/Masters/StateMaster/StateMasterDashboard";
import { getAuthenticationType, getQueryOnChat, msgCountForEmp, updateIsReadFlagForEmp, userLogout } from "../Helpers/APIEndpoints/Endpoints";
import RegionMasterDashboard from "../Pages/Masters/RegionMaster/RegionMasterDashboard";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  StarOutlined,
  FileSearchOutlined,
  DatabaseOutlined,
  AppstoreOutlined,
  UserOutlined,
  DownOutlined,
  CommentOutlined,
  HomeOutlined,
  DashboardOutlined,
  AreaChartOutlined,
  FileOutlined,
  CalendarOutlined,
  UserSwitchOutlined,
  SyncOutlined,
  SettingOutlined,
  FileTextOutlined,
  AppstoreAddOutlined,
  TeamOutlined,
  
  DollarOutlined,
  BuildOutlined
} from "@ant-design/icons";
import { JSX } from "react/jsx-runtime";
import { Avatar, Badge, Button, Card, Dropdown, Flex, Layout, Menu, Modal, Select, theme } from "antd";
import DynamicReport from "../Components/DynamicReport/DynamicReport";
import DynamicMaster from "../Components/DynamicMaster/DynamicMaster";
import InterfaceComponent from "../Pages/Masters/InterfaceComponent";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import VerificationPOI from "../Pages/VerificationPOI/VerificationPOI";
import EmployeeTabs from "../Pages/EmployeeTabs/Employeetabs";
import FinancialYearMaster from "../Pages/FinancialYearMaster/FinancialYearMaster";
import UserAccessMaster from "../Pages/UserAccessMaster/UserAccessMaster";
import InvestmentCycleMaster from "../Pages/InvestmentCycleMaster/InvestmentCycleMaster";
import ConfigurationMaster from "../Pages/ConfigurationMaster/ConfigurationMaster";
import DocumentTypeMaster from "../Pages/DocumentTypeMaster/DocumentTypeMaster";
import SectionMaster from "../Pages/SectionMaster/SectionMaster";
import EmployeeMaster from "../Pages/EmployeeMaster/EmployeeMaster";
import ComponentMaster from "../Pages/ComponentMaster/ComponentMaster";
import menu from "antd/es/menu";
import { FormDate } from "../Components/FormDate";
//import EmployeeGeneralInfo from "../Pages/EmployeeGeneralInfo/EmployeeGeneralInfo";
// import VerificationPOI from "../Pages/VerificationPOI/VerificationPOI";
import AllowanceMaster from "../Pages/AllowanceMaster/AllowanceMaster";
import EmployeeRecord from "../Pages/EmployeeRecord/EmployeeRecord";
import Modals from "../Components/Modals/modal";
import TextArea from "antd/es/input/TextArea";
import RequirePermission from "./RequirePermission";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import RequireAccess from "./RequirePermission";
import ChatBox from "../Components/Chatbox/ChatBox";
import Form12bb from "../Pages/Form12bb/Form12bb";
import VerificationDashboard from "../Pages/EmployeeRecord/VerificationDashboard";
import ReportRequestDashboard from "../Pages/ReportRequest/ReportRequestDashboard";
import axios from "axios";



export const AllRoutes = {
  Home: { link: "/Home", title: "Home", pname: "Home" },
};

const RoutesComponent = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const siderRef: any = useRef(null);
  const { financialYearList, currentFinancialYearId, userId,
    setzustandFinancialYearDetails, logout } = useAuthStore();

  const { instance } = useMsal();
  const { Header, Sider, Content, Footer } = Layout;
  const [isOpen, setIsOpen] = useState(false);
  const [superAdminorAdminarray, setsuperAdminorAdminArray] = useState<any>([1, 2]);
  const [superAdminOrAdminOrVerifierarray, setsuperAdminOrAdminOrVerifierArray] = useState<any>([1, 2, 3]);
  const [allRoleArray, setAllroleArray] = useState<any>([1, 2, 3, 4]);      //only for employee
  const [onlyEmployeeRoleArray, setOnlyEmployeeRoleArray] = useState<any>([4]);
  const { currentRoleId, currentuserroleList } = useAuthStore();
  const [items, setItem] = useState<any>([]);
  const [msgCount, setMsgCount] = useState(0);

  // console.log('current userlist///////', currentuserroleList)
  // console.log('current role id///////', currentRoleId)
  const location = useLocation();
  const type = location.state?.type;
  const [OpenMessage, setOpenMessage] = useState<any>(false);
  const [queryList, setQueryList] = useState<any>([]);
  const isAuthenticated = useIsAuthenticated();
  function getItem(
    label: string,
    key: string,
    icon: JSX.Element,
    children:
      | {
        label: any;
        key: any;
        icon: any;
        children: any;
        link: any;
        id: Number;
        dashboardId: Number;
      }[]
      | null,
    link: string | null,
    id: Number,
    dashboardId: Number,
    condition: boolean = true,
  ) {
    return {
      label,
      key,
      icon,
      children,
      link,
      id,
      dashboardId,
      condition,
    };
  }

  useEffect(() => {
    if (currentuserroleList) {
     // console.log("currentuserrolelist", currentuserroleList)
      const usrRoleListArr = (Array.isArray(currentuserroleList) ? currentuserroleList : []).map((role: any) => role.Id);
      let masterScreenArr = [
        "ManageFinancialYearMaster", "ManageConfigurationMaster", "ManageUserAccessMaster", "ManageInvestmentCycleMaster",
        "ManageDocumentTypeMaster", "ManageSectionMaster", "ManageEmployeeMaster", "ManageComponentMaster",
        "ManageAllowanceMaster"
      ]

      let hasMasterPermission = masterScreenArr.some((required: string) =>
        (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) =>
          role.permissionsList?.some((perm: any) =>
            perm.SystemName === required
          )
        ))

     // console.log('inside role ', usrRoleListArr)
      const items = [
        // getItem(
        //   "Performance Rating",
        //   "1",
        //   <StarOutlined />,
        //   null,
        //   "/InterfaceComponent",
        //   9,
        //   0
        // ),
        // getItem("Search", "2", <FileSearchOutlined />, null, "", 7, 0),
        getItem("Home", "VerificationPOI", <HomeOutlined />, null, "/VerificationPOI", 0, 0, superAdminOrAdminOrVerifierarray.some((role: any) => usrRoleListArr.includes(role))),

        getItem("Employee Details", "EmpDetail", <AreaChartOutlined />, null, "/EmployeeTabs", 12, 12, onlyEmployeeRoleArray.some((role: any) => usrRoleListArr?.includes(role))),
        getItem("Employee Record", "EmpRecord", <FileSearchOutlined />, null, "/EmployeeRecord", 0, 10, superAdminOrAdminOrVerifierarray.some((role: any) => usrRoleListArr?.includes(role))),
        // getItem(
        //   "Personal Data",
        //   "3",
        //   <DatabaseOutlined />,
        //   null,
        //   "/DynamicReport",
        //   8,
        //   0
        // ),
        getItem(
          "Masters",
          "sub1",
          <AppstoreOutlined />,
          [
            // getItem(
            //   "State",
            //   "sub1-1",
            //   <AppstoreOutlined />,
            //   null,
            //   "/StateMasterDashboard",
            //   3,
            //   1
            // ),
            // getItem(
            //   "Region",
            //   "sub1-2",
            //   <AppstoreOutlined />,
            //   null,
            //   "/RegionMasterDashboard",
            //   4,
            //   2
            // ),
            // getItem("Event", "sub1-3", <AppstoreOutlined />, null, "/", 5, 3),
            // getItem(
            //   "User",
            //   "sub1-4",
            //   <StarOutlined />,
            //   null,
            //   "/DynamicFormComponent",
            //   10,
            //   0
            // ),
            // getItem(
            //   "Investment Category",
            //   "sub1-5",
            //   <StarOutlined />,
            //   null,
            //   "/DynamicFormComponent",
            //   11,
            //   0
            // ),
            // getItem(
            //   "Dynamic Master",
            //   "sub1-6",
            //   <StarOutlined />,
            //   null,
            //   "/DynamicMaster",
            //   11,
            //   3
            // ),
            getItem(
              "Financial Year Master",
              "sub1-7",
              <CalendarOutlined />,
              null,
              "/FinancialYearMaster",
              1,
              1,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageFinancialYearMaster"))
            ),
            getItem(
              "User Access Master",
              "sub1-8",
              <UserSwitchOutlined />,
              null,
              "/UserAccessMaster",
              2,
              2,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageUserAccessMaster"))
            ),
            getItem(
              "Investment Cycle Master",
              "sub1-9",
              <SyncOutlined />,
              null,
              "/InvestmentCycleMaster",
              3,
              3,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageInvestmentCycleMaster"))
            ),
            getItem(
              "Configuration Master",
              "sub1-10",
              <SettingOutlined />,
              null,
              "/ConfigurationMaster",
              4,
              4,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageConfigurationMaster"))
              //true//permissionRecord.some( (role:any) => role == "ManageConfigurationMaster")
            ),
            getItem(
              "Document Type Master",
              "sub1-11",
              <FileTextOutlined />,
              null,
              "/DocumentTypeMaster",
              5,
              5,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageDocumentTypeMaster"))
            ),
            getItem(
              "Section Master",
              "sub1-12",
              <AppstoreAddOutlined />,
              null,
              "/SectionMaster",
              7,
              7,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageSectionMaster"))
            ),
            getItem(
              "Employee Master",
              "sub1-13",
              <TeamOutlined />,
              null,
              "/EmployeeMaster",
              0,
              6,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageEmployeeMaster"))
              // true//permissionRecord.some( (role:any) => masterScreenArr?.includes(role))
            ),
            getItem(
              "Component Master",
              "sub1-14",
              <BuildOutlined />,
              null,
              "/ComponentMaster",
              6,
              8,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageComponentMaster"))
            ),
            getItem(
              "Allowance Master",
              "sub1-15",
              <DollarOutlined />,
              null,
              "/AllowanceMaster",
              8,
              9,
              (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.some((role: any) => role.permissionsList?.some((perm: any) => perm.SystemName === "ManageAllowanceMaster"))
            ),

          ].filter((condition) => condition.condition),
          null,
          0,
          0,
          hasMasterPermission
        ),
        getItem("Reports", "ReportMaster", <FileOutlined />, null, "/Reports", 0, 0, superAdminorAdminarray.some((role: any) => usrRoleListArr.includes(role))),
      ].filter((condition) => condition.condition);

      setItem(items);
    }

  }, [currentuserroleList])

  // const itemsss = [
  //   getItem("Home", "VerificationPOI", <HomeOutlined />, null, "/VerificationPOI", 0, 0,superAdminorAdminarray.some( (role:any) => currentuserroleList?.map((roles:any)=> roles.Id) ?.includes(role)) ),
  // ].filter((condition)=>condition.condition)
  // console.log('item array is',items)

  // const itemss = [
  //   // getItem(
  //   //   "Performance Rating",
  //   //   "1",
  //   //   <StarOutlined />,
  //   //   null,
  //   //   "/DynamicFormComponent",
  //   //   9,
  //   //   0
  //   // ),
  //   // getItem("Search", "2", <FileSearchOutlined />, null, "", 7, 0),
  //   getItem("Home", "VerificationPOI", <HomeOutlined />, null, "/VerificationPOI", 0, 0,superAdminorAdminarray.some( (role:any) => currentuserroleList?.map((roles:any)=> roles.Id) ?.includes(role)) ),

  //   getItem("Employee Details", "EmpDetail", <FileSearchOutlined />, null, "/EmployeeTabs", 12, 12,allRoleArray.some( (role:any) => usrRoleListArr?.includes(role)) ),
  //   getItem("Employee Record", "EmpRecord", <FileSearchOutlined />, null, "/EmployeeRecord", 0, 10,superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))),
  //   // getItem(
  //   //   "Personal Data",
  //   //   "3",
  //   //   <DatabaseOutlined />,
  //   //   null,
  //   //   "/DynamicReport",
  //   //   8,
  //   //   0
  //   // ),
  //   getItem(
  //     "Masters",
  //     "sub1",
  //     <AppstoreOutlined />,
  //     [
  //       // getItem(
  //       //   "State",
  //       //   "sub1-1",
  //       //   <AppstoreOutlined />,
  //       //   null,
  //       //   "/StateMasterDashboard",
  //       //   3,
  //       //   1
  //       // ),
  //       // getItem(
  //       //   "Region",
  //       //   "sub1-2",
  //       //   <AppstoreOutlined />,
  //       //   null,
  //       //   "/RegionMasterDashboard",
  //       //   4,
  //       //   2
  //       // ),
  //       // getItem("Event", "sub1-3", <AppstoreOutlined />, null, "/", 5, 3),
  //       // getItem(
  //       //   "User",
  //       //   "sub1-4",
  //       //   <StarOutlined />,
  //       //   null,
  //       //   "/DynamicFormComponent",
  //       //   10,
  //       //   0
  //       // ),
  //       // getItem(
  //       //   "Investment Category",
  //       //   "sub1-5",
  //       //   <StarOutlined />,
  //       //   null,
  //       //   "/DynamicFormComponent",
  //       //   11,
  //       //   0
  //       // ),
  //       // getItem(
  //       //   "Dynamic Master",
  //       //   "sub1-6",
  //       //   <StarOutlined />,
  //       //   null,
  //       //   "/DynamicMaster",
  //       //   11,
  //       //   3
  //       // ),
  //       getItem(
  //         "Financial Year Master",
  //         "sub1-7",
  //         <StarOutlined />,
  //         null,
  //         "/FinancialYearMaster",
  //         1,
  //         1,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "User Access Master",
  //         "sub1-8",
  //         <StarOutlined />,
  //         null,
  //         "/UserAccessMaster",
  //         2,
  //         2,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Investment Cycle Master",
  //         "sub1-9",
  //         <StarOutlined />,
  //         null,
  //         "/InvestmentCycleMaster",
  //         3,
  //         3,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Configuration Master",
  //         "sub1-10",
  //         <StarOutlined />,
  //         null,
  //         "/ConfigurationMaster",
  //         4,
  //         4,
  //         allRoleArray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Ducument Type Master",
  //         "sub1-11",
  //         <StarOutlined />,
  //         null,
  //         "/DocumentTypeMaster",
  //         5,
  //         5,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Section Master",
  //         "sub1-12",
  //         <StarOutlined />,
  //         null,
  //         "/SectionMaster",
  //         7,
  //         7,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Employee Master",
  //         "sub1-13",
  //         <StarOutlined />,
  //         null,
  //         "/EmployeeMaster",
  //         0,
  //         6,
  //         allRoleArray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Component Master",
  //         "sub1-14",
  //         <StarOutlined />,
  //         null,
  //         "/ComponentMaster",
  //         6,
  //         8,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),
  //       getItem(
  //         "Allowance Master",
  //         "sub1-15",
  //         <StarOutlined />,
  //         null,
  //         "/AllowanceMaster",
  //         8,
  //         9,
  //         superAdminorAdminarray.some( (role:any) => usrRoleListArr?.includes(role))
  //       ),

  //     ].filter((condition)=>condition.condition),
  //     null,
  //     0,
  //     0,
  //     allRoleArray.some( (role:any) => usrRoleListArr?.includes(role))
  //   ) 
  // ].filter((condition)=>condition.condition);

 // console.log('role array is', items)
  // Detect if the viewport is in mobile view
 
  useEffect(() => {
    console.log("handleResize () ");
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Adjust for "lg" breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close Sider when clicking outside
  useEffect(() => {
    console.log("handleClickOutside () ");
    const handleClickOutside = (event: any) => {
      if (siderRef.current && !siderRef.current.contains(event.target)) {
        setCollapsed(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  const handleClick = (e: { key: any }) => {
    const item = items
      .flatMap((i: any) => [i, ...(i.children || [])]) // Flatten the menu tree
      .find((i: any) => i.key === e.key);

    if (item && item.link) {
      navigate(item.link); // Navigate to the item's link
    }
    // if (item && item.link === "/DynamicMaster") {
    //   navigate(item.link, {
    //     state: { id: item.id, dashboardId: item.dashboardId },
    //   }); // Navigate to the item's link
    // } else if (item && item.dashboardId == 0) {
    //   navigate("/DynamicFormComponent", {
    //     state: { id: item.id, dashboardId: item.dashboardId },
    //   });
    // } else if (item && item.dashboardId == 12) {
    //   navigate("/EmployeeTabs", {
    //     state: { id: item.id, dashboardId: item.dashboardId },
    //   });
    // } else {
    //   navigate("/DynamicReport", {
    //     state: { id: item?.id, dashboardId: item?.dashboardId },
    //   });
    // }
  };

  // const isAuthenticated = useIsAuthenticated();
  // const [menuOpen, setMenuOpen] = useState(false);
  // const context = {}; //[PENDING] get user data from backend/localStorage //useSelector(selectedDroDownUser);
  // const permissions = {}; //[PENDING] get user permissions from backend/localStorage //useSelector(userPermissions);
  // const mobileResMenu = () => {
  //   setMenuOpen(!menuOpen);
  // };
  const [loginType, setLoginType] = useState<string | null>(null); // State to hold the login type
  const { username, setredirectUrlPostLogin, redirectUrlPostLogin } =
    useAuthStore(); //rememberMe, externalUrl, setExternalUrl
 
  useEffect(() => {
    console.log("fetchLoginType");
    // Function to fetch login type from the API
    const fetchLoginType = async () => {
      try {
        const response = await APIwithoutInterceptor.post(
          getAuthenticationType
        );

        // Parse the JSON response
        const data = await response.data;

        // Set the parsed authentication object in state
        setLoginType(data.data);
       // console.log('currentRoleId', currentRoleId);
       // console.log("Current Username:", username);
       // console.log("Login Type: ", data);
      } catch (error) {
        console.error("Failed to fetch login type:", error);
      }
    };

    fetchLoginType();
  }, []);

  // Store attempted URL if user is not logged in
  useEffect(() => {
    console.log("[username, location.pathname, redirectUrlPostLogin] username : " + username);
    console.log("[username, location.pathname, redirectUrlPostLogin] location.pathname : " + location.pathname);
    console.log("[username, location.pathname, redirectUrlPostLogin] redirectUrlPostLogin : " + redirectUrlPostLogin);

    if (
      !username &&
      location.pathname !== "/login" &&
      location.pathname !== "/forgot-password"
    ) {      
      console.log("!username && location.pathname !== /login && location.pathname !== /forgot-password");
      
      // window.location.href = "/login";
      navigate("/login");
      setredirectUrlPostLogin(location.pathname); // Save the path user attempted to visit
    }
  }, [username, location.pathname, redirectUrlPostLogin]);

  // Redirect to external URL after login
  useEffect(() => {
    console.log("[username, redirectUrlPostLogin] username : " + username);
    console.log("[username, redirectUrlPostLogin] redirectUrlPostLogin : " + redirectUrlPostLogin);
    if (username && redirectUrlPostLogin) {
      // window.location.href = redirectUrlPostLogin; // Use `navigate` instead of full reload
    //  console.log("redirectUrlPostLogin", redirectUrlPostLogin)
      //navigate(redirectUrlPostLogin);
      setredirectUrlPostLogin(null); // Clear after navigating
    }
  }, [username, redirectUrlPostLogin]);

  // const { Header } = Layout;

  const getUserIP = async () => {
      try {
        const response = await axios.get("https://api64.ipify.org?format=json");
        const data = await response.data;
        console.log("ip data:", data);
        return data.ip; // Extract the IP address
      } catch (error) {
        console.error("Error fetching IP:", error);
        return null;
      }
    };
  
    // This is for getting the user Context
    const getUserContext = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    };


const clearAppSession = () => {
  // 🔹 Clear MSAL redirect flag
  sessionStorage.removeItem("azureRedirectInProgress");

  // 🔹 Clear tokens
  useNonPersistAuthStore.getState().setJWTAccessTokenDev("");

  // 🔹 Clear Zustand user data
  logout(); // your existing logout() action

  // 🔹 Clear storage (if used)
  sessionStorage.clear();
  localStorage.clear();
};


  const handleLogout = async () => {
    try {
      if (type === "Entra") {
        const account = instance.getActiveAccount();

        clearAppSession();

        await instance.logoutRedirect({
          account,
          postLogoutRedirectUri: window.location.origin,
        });

        return; // 🔥 redirect happens
      }

      // 🔹 Custom logout
      const ip = await getUserIP();
      const userContext = getUserContext();

      await APIwithoutInterceptor.post(userLogout, {
        loginId: username,
        ipAddress: ip,
        ...userContext,
      });

      clearAppSession();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      clearAppSession();
      navigate("/");
    }
  };




  let widthSize = "large"
  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();

  const financialCycyle = (e: any) => {
   // console.log(e);
    setzustandFinancialYearDetails(e);
    navigate("/");
  }

  const getQuery = async () => {
    setIsOpen(true);
   // console.log('hhhhhhhhhhhhhhhhhh role', currentRoleId)

    const res = await API.post(getQueryOnChat, {
      UserId: userId,
      FinancialYearId: currentFinancialYearId,
      IsVerifier: false,
    })

   // console.log('res on chat===>', res)
    if (res.data.data.length > 0) {
      setQueryList(res?.data?.data);
      await markAsRead();
      setMsgCount(0);
    } else {
      setQueryList([])
    }
  }
  const markAsRead = async () => {

    const res = await API.post(updateIsReadFlagForEmp, {
      UserId: userId,
      FinancialYearId: currentFinancialYearId
    })

  }

  const getNotificationCountForEmp = async () => {
    const res = await API.post(msgCountForEmp, {
      UserId: userId,
      FinancialYearId: currentFinancialYearId
    })

   // console.log('notification count==>', res.data.data)
    if (res.data.data) {
      setMsgCount(res.data.data)
    }
  }

  useEffect(() => {
    console.log('feth notification count',isAuthenticated,userId,location?.pathname)
    if (isAuthenticated) {
      getNotificationCountForEmp();
    }
  }, [userId,location?.pathname])
  
  // const innerModal = async (obj: any) => {
  //   setInnerModalOpen(true);
  //   setInnerModalData(obj);
  // }

  // const msgHandle = (e: any) => {
  //   console.log(e.target.value);
  //   setInnerModalMsg(e.target.value);
  // }
  // const handleSubmit = () => {
  //   setInnerModalOpen(false);
  //   alert('data submitted');

  // }
  // console.log('query inner obj==>', innerModalData);

  const Redirect = () => {
    let usrRoleListAr = (Array.isArray(currentuserroleList) ? currentuserroleList : [])?.map((role: any) => role.Id);
    let redirectUrl = superAdminOrAdminOrVerifierarray?.some((roles: any) => usrRoleListAr.includes(roles)) ? "/VerificationPOI" : "/EmployeeTabs"
    return <Navigate to={redirectUrl} />;
  };


  return (
    <>
      {/* <div className="header-fixed">
        <div id="base">
          <div id="content">
            <div className="main-content">
              <div className="inner-content">
                <Routes>
                  <Route path="/" element={<Login />} />
                  <Route
                    path="/DynamicFormComponent"
                    element={<DyanmicFormComponent />}
                  />
                  <Route
                    path="/DynamicDashboard"
                    element={<DynamicDashboard />}
                  />
                  <Route
                    path="/StateMasterDashboard"
                    element={<StateMasterDashboard />}
                  />

                  <Route
                    path="/RegionMasterDashboard"
                    element={<RegionMasterDashboard />}
                  />

                  <Route path="*" element={<CustomErrorPage />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div> */}

      {location.pathname === "/login" ? (
        <Routes>
          <Route
            path="/login"
            element={
              loginType ? (
                <LoginPage type={loginType} />
              ) : (
                <p>Loading login type...</p>
              )
            }
          />
        </Routes>
      ) : (
        <Layout>
          <Sider
            style={{
              height: "100vh",
              position: "fixed",
              left: 0,
              top: (isMobile ? 64 : 0),
              zIndex: 10,
              // Ensures it stays on top of other elements
            }}
            trigger={null}
            collapsible
            collapsed={collapsed}
            breakpoint="lg"
            collapsedWidth={isMobile ? 0 : 60} // 0px on mobile, 80px on desktop
            width={250} // Full width when expanded
            ref={siderRef}
            className="siderBg"
          >
            {/* <div className="logo">
            <img src={collapsed ? smallLogo : bigLogo} alt="WOW Logo" />
          </div> */}
            <div className="logo text-center py-3 d-lg-block d-none">
              <img src="/Images/TataLogo.png" alt="Logo" />
            </div>
            <div className="scrollbar" id="custom-scroll">
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={["1"]}
                items={items}
                className="menu_items"
                onClick={handleClick}
              />
            </div>
            <div
              className="side_bottom"
              style={{
                display: isMobile && collapsed ? "none" : "block",
                bottom: isMobile ? "64px" : "0px",
              }}
            >
              {/* <div className="media">
              <div className="media-left">
                <img src={profileImage} alt="user profile icon" />
              </div>
              <div
                className="media-body-inner"
                style={{ display: collapsed ? "none" : "flex" }}
              >
                <div className="media-body">
                  <h3>Anuj Pandey</h3>
                  <a href="#/urlhere">View Profile</a>
                </div>
                <div className="media-right">
                  <span><FaPowerOff /></span>
                </div>
              </div>
            </div> */}
            </div>
          </Sider>
          <Layout
            style={{

              marginLeft: collapsed ? (isMobile ? 0 : 60) : (isMobile ? 0 : 250), // Adjust content margin based on Sider width
              transition: "0.3s",
            }}
          >
            <Header
              style={{
                padding: 0,
                background: colorBgContainer,
              }}
              className="header d-flex align-items-center justify-content-between"
            >
              <div className="leftProfile d-flex align-items-center flex-direction-row">
                <Button className="hamburgr_icon"
                  type="text"
                  icon={
                    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                  }
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: "20px",
                    width: 64,
                    height: 64,
                    border: 0,
                  }}
                />
                <h2 className="portalName">TaxSpace</h2>
              </div>
              <div className="rightProfile d-flex align-items-center">
                <div className="mainDate mx-3">
                  {/* <FormDate />  */}
                  <Select
                    // showSearch
                    // optionFilterProp="label"
                    // placeholder={placeholder}
                    value={(financialYearList ?? []).filter((x: any) => x.value == currentFinancialYearId)}
                    options={financialYearList || []}
                    // {...rest}
                    // style={{ width: widthPercentage }}
                    //di
                    onChange={(e: any) => financialCycyle(e)}
                  />
                </div>
                <div className="badgeParent">
                  {
                    currentuserroleList && currentuserroleList?.some((role: any) =>
                      role.SystemName === 'Employee'
                    ) ?
                      <>
                        <Badge count={msgCount} overflowCount={99} color="#8358f3">
                          <CommentOutlined className="commIcn" onClick={() => getQuery()}
                          />
                        </Badge>
                      </>
                      :
                      <></>
                  }

                </div>


                {isOpen &&
                  <>
                    <Flex vertical gap="middle" align="flex-start">
                      <Modal
                        title="Message List"
                        centered
                        open={isOpen}
                        onCancel={() => setIsOpen(false)}
                        footer={false}
                        width={{
                          xs: '80%',
                          sm: '80%',
                          md: '80%',
                          lg: '40%',
                          xl: '50%',
                          xxl: '50%',
                        }}  >
                        {/* <hr style={{ border: "1px solid var(--dark-color)" }}></hr> */}
                        <div className="messageList">
                          <ChatBox message={queryList} touserid={"0"} type={"Employee"}/>
                          {/* {queryList && queryList.map((ele: any) => {
                            return (<>
                              <Card onClick={() => { innerModal(ele) }}>
                                <div className='Message'>
                                  <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                    <div className='w-49'><h5>Employee Name :</h5> <span>{ele?.employeeName}</span></div>
                                    <div className='w-49'><h5>Employee Code :</h5> <span>{ele?.employeeCode}</span></div>
                                  </div>
                                  <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                    <h5>Message :</h5> <span>{ele?.message}</span>
                                  </div>
                                </div>
                              </Card>

                            </>)
                          })} */}

                        </div>
                      </Modal>
                    </Flex>

                  </>
                }

                {/* {innerModalOpen &&
                  <>
                    {/* <Flex vertical gap="middle" align="flex-start">
                      <Modal
                        title="Message List"
                        centered
                        open={innerModalOpen}
                        onCancel={() => setInnerModalOpen(false)}
                        footer={false}
                        width={{
                          xs: '80%',
                          sm: '80%',
                          md: '80%',
                          lg: '40%',
                          xl: '50%',
                          xxl: '50%',
                        }}  >
                        <hr style={{ border: "1px solid var(--dark-color)" }}></hr>
                        <Card className='MessAdd'>
                          <div className='messageAdd'>
                            <div className='Message'>
                              <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                <div className='w-49'><h5>Employee Name :</h5> <span>{innerModalData?.employeeName}</span></div>
                                <div className='w-49'><h5>Employee Code :</h5> <span>{innerModalData?.employeeCode}</span></div>
                              </div>
                              <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                <h5>Verrifier :</h5> <span>Revised document submitted</span>
                              </div>
                              {/* <div className='d-flex w-100 align-items-flex-center flex-column mb-3'>
                                        <span className='ms-0 my-1'>Employees : Revised document submitted</span>
                                        <a href='#'>Revised Document 01</a>
                                    </div> *
                              <TextArea onChange={(e: any) => msgHandle(e)} rows={3} />
                              <div className='w-100 mt-3 mb-1 d-flex justify-content-end subbtn'>
                                <Button type='primary' className='btn-submit' onClick={() => handleSubmit()}>Submit</Button>
                              </div>

                            </div>
                          </div>
                        </Card>
                        
                      </Modal>
                    </Flex> *
                   
                  </>
                } */}

                {/* <Modals openKey={OpenMessage} />} */}


                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "0 15px",
                  }}
                >
                  <Dropdown
                    className="userLog"
                    trigger={["click"]}
                    placement="bottomLeft"
                    dropdownRender={() => (
                      <Button
                        className="logoutbtn"
                        type="text"
                        onClick={handleLogout}
                        //onClick={logout()}
                        style={{ width: "100%" }}
                      >
                        Logout
                      </Button>
                    )}
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Avatar
                        className="avtaricn"
                        size="large"
                        icon={<UserOutlined />}
                      />
                      <DownOutlined />
                    </div>
                  </Dropdown>
                </div>
              </div>
            </Header>
            <Content
              style={{
                margin: "16px 8px 48px",
                // padding: "20px",
                // height: "100vh",
                // background: colorBgContainer,
                // borderRadius: borderRadiusLG,
              }}
            >
              <Routes>
                {/* <Route
                  path="/login"
                  element={
                    loginType ? (
                      <LoginPage type={loginType} />
                    ) : (
                      <p>Loading login type...</p>
                    )
                  }
                /> */}

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>

                  <Route
                    path="/DynamicFormComponent"
                    element={<DyanmicFormComponent formSections={undefined} />}
                  />
                  <Route path="/home" element={<DocumentView />} />

                  <Route path="/access-denied" element={<AccessDenied />} />

                  <Route
                    path="/VerificationPOI"
                    element={
                      <RequireAccess allowedRoles={superAdminOrAdminOrVerifierarray}>
                        <VerificationPOI />
                      </RequireAccess>
                    }
                  />
                  <Route
                    path="/EmployeeTabs"
                    element={
                      <RequireAccess allowedRoles={allRoleArray}>
                        <EmployeeTabs />
                      </RequireAccess>
                    }
                  />
                  <Route
                    path="/DynamicReport"
                    element={<DynamicReport props={undefined} />}
                  />
                  <Route
                    path="/StateMasterDashboard"
                    element={<StateMasterDashboard />}
                  />
                  {/* <Route path="/DynamicMaster" element={<DynamicMaster />} /> */}

                  <Route
                    path="/FinancialYearMaster"
                    element={
                      <RequireAccess requiredPermissions={["ManageFinancialYearMaster"]}>
                        <FinancialYearMaster />
                      </RequireAccess>}
                  />

                  <Route
                    path="/UserAccessMaster"
                    element={
                      <RequireAccess requiredPermissions={["ManageUserAccessMaster"]}>
                        <UserAccessMaster />
                      </RequireAccess>}
                  />

                  <Route path="/InvestmentCycleMaster"
                    element={
                      <RequirePermission requiredPermissions={["ManageInvestmentCycleMaster"]}>
                        <InvestmentCycleMaster />
                      </RequirePermission>
                    }
                  />

                  <Route
                    path="/ConfigurationMaster"
                    element={
                      <ConfigurationMaster />
                    }

                  />
                  <Route
                    path="/DocumentTypeMaster"
                    element={
                      <RequirePermission requiredPermissions={["ManageDocumentTypeMaster"]}>
                        <DocumentTypeMaster />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/SectionMaster"
                    element={
                      <RequirePermission requiredPermissions={["ManageSectionMaster"]}>
                        <SectionMaster />
                      </RequirePermission>
                    }

                  />
                  <Route
                    path="/InterfaceComponent"
                    element={<InterfaceComponent />}
                  />
                  <Route
                    path="/InterfaceComponent"
                    element={<InterfaceComponent />}
                  />

                  <Route
                    path="/EmployeeMaster"
                    element={<EmployeeMaster />}
                  />
                  <Route
                    path="/ComponentMaster"
                    element={
                      <RequirePermission requiredPermissions={["ManageComponentMaster"]}>
                        <ComponentMaster />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/AllowanceMaster"
                    element={
                      <RequirePermission requiredPermissions={["ManageAllowanceMaster"]}>
                        <AllowanceMaster />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/EmployeeRecord"
                    element={<EmployeeRecord />}
                  />

                  <Route
                    path="/VerificationDashboard"
                    element={<VerificationDashboard />}
                  />
                  <Route
                    path="/form12bb"
                    element={<Form12bb />}
                  />

                  <Route
                    path="/Reports"
                    element={<ReportRequestDashboard />}
                  />

                </Route>
                {/* Add all protected pages here */}
                <Route path="/forgot-password" element={<ForgotPassword />} />

                {/* Default Redirect */}

                <Route
                  path="*"
                  element={
                    !username ? (
                      
                      <Navigate to="/login" />
                      
                    ) : (<Redirect />)
                  }
                />
              </Routes>
            </Content>
            <Footer className="footer">
              <p>@Copyrights 2025-2026 Tata Motors Limited All Rights Reserved.</p>
            </Footer>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default RoutesComponent;
